module.exports = "<div class=row-eq-height ng-repeat=\"contentChunk in contentChunks\"> <div class=col-xs-6 ng-repeat=\"content in contentChunk\"> <practical-example-video data=content></practical-example-video> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./web/js/module/practicalExample/js/videoGroup/videoGroup.html
// module id = 1125
// module chunks = 0